import React, { useContext } from 'react';
import LoadingScreen from './LoadingScreen';
import AppContext from '../context';

const Loader = () => {
  const { alertState } = useContext(AppContext);
  return (
    <>
      {alertState.loader ? (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 999
          }}
        >
          <LoadingScreen />
        </div>
      ) : null}
    </>
  );
};

export default Loader;
